"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _react = _interopRequireWildcard(require("react")),
    _lodash = _interopRequireDefault(require("lodash.memoize")),
    _lodash2 = _interopRequireDefault(require("lodash.get")),
    _Tab = _interopRequireDefault(require("./Tab"));

require("../styles/_tabs.scss");

function _createSuper(a) {
  return function () {
    var b,
        c = (0, _getPrototypeOf2["default"])(a);

    if (_isNativeReflectConstruct()) {
      var d = (0, _getPrototypeOf2["default"])(this).constructor;
      b = Reflect.construct(c, arguments, d);
    } else b = c.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, b);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var Tabs = function (a) {
  function b(a) {
    var d;
    return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), d.onSelectTab = (0, _lodash["default"])(function (a) {
      return function () {
        var b = d.props.updateSelectedTabIndex;
        d.setState({
          selectedTabIndex: a
        }), b({
          selectedTabIndex: a
        });
      };
    }), d.state = {
      selectedTabIndex: a.initialIndex || 0
    }, d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "render",
    value: function render() {
      var a = this,
          b = this.props.children,
          c = _react.Children.toArray(b),
          d = this.state.selectedTabIndex;

      return _react["default"].createElement("div", {
        className: "tabs"
      }, _react["default"].createElement("ol", {
        className: "tabs__list"
      }, c.map(function (b, c) {
        return _react["default"].createElement(_Tab["default"], {
          key: (0, _lodash2["default"])(b, "props.title"),
          isSelected: c === d,
          title: (0, _lodash2["default"])(b, "props.title"),
          onClick: a.onSelectTab(c)
        });
      })), _react["default"].createElement("div", {
        className: "tabs__tab-content"
      }, c[d]));
    }
  }]), b;
}(_react.Component);

exports["default"] = Tabs;